import { useEffect, useRef, useState } from "react";
import { useAppSelector } from "../../../../hooks";
import { selectInputMessage } from "../../selectors";
import { Context } from "./context";
import {
  DEFAULT_DOWN_BUTTON_OFFSET,
  DEFAULT_FILE_LIST_HEIGHT,
  DEFAULT_TEXT_INPUT_HEIGHT,
  MAX_TEXT_INPUT_HEIGHT,
  OPENED_REPLY_MESSAGE_HEIGHT,
  DEFAULT_REPLY_MESSAGE_HEIGHT,
} from "./constants";
import type { ProviderProps } from "./types";

export const InputHeightProvider = ({ children }: ProviderProps) => {
  const message = useAppSelector(selectInputMessage).text;
  const [textInputHeight, setTextInputHeight] = useState(
    DEFAULT_TEXT_INPUT_HEIGHT
  );

  const [fileListHeight, setFileListHeight] = useState(
    DEFAULT_FILE_LIST_HEIGHT
  );

  const [replyMessageHeight, setReplyMessageHeight] = useState(
    DEFAULT_REPLY_MESSAGE_HEIGHT
  );

  const textareaRef = useRef<HTMLTextAreaElement>({} as HTMLTextAreaElement);

  const setFocusToInput = () => {
    textareaRef.current?.focus?.();
  };

  const handleChangeFileListHeight = (height: number) =>
    setFileListHeight(height);

  const handleChangeReplyMessageHeight = (hasMessage: boolean) =>
    setReplyMessageHeight(
      hasMessage ? OPENED_REPLY_MESSAGE_HEIGHT : DEFAULT_REPLY_MESSAGE_HEIGHT
    );

  useEffect(() => {
    if (textareaRef && textareaRef.current) {
      const control = textareaRef.current;

      // TODO скорее всего if можно убрать
      // if (!message.length) {
      //   control.style.height = `${DEFAULT_TEXT_INPUT_HEIGHT}px`;
      //   setTextInputHeight(DEFAULT_TEXT_INPUT_HEIGHT);
      // } else {
      control.style.height = `${DEFAULT_TEXT_INPUT_HEIGHT}px`;

      const isScrollMoreThanMax = control.scrollHeight > MAX_TEXT_INPUT_HEIGHT;
      const currentOverflow = isScrollMoreThanMax ? "auto" : "hidden";
      const isScrollLessThanDefault =
        control.scrollHeight < DEFAULT_TEXT_INPUT_HEIGHT;

      const currentHeight = isScrollLessThanDefault
        ? DEFAULT_TEXT_INPUT_HEIGHT
        : control.scrollHeight;

      const correctedHeight = isScrollMoreThanMax
        ? MAX_TEXT_INPUT_HEIGHT
        : currentHeight;

      control.style.height = `${correctedHeight}px`;
      control.style.overflowY = currentOverflow;
      setTextInputHeight(correctedHeight);
      // }
    }
  }, [message]);

  return (
    <Context.Provider
      value={{
        textareaRef,
        textInputHeight,
        fileListHeight,
        replyMessageHeight,
        downButtonOffset: DEFAULT_DOWN_BUTTON_OFFSET,
        setFocusToInput,
        handleChangeFileListHeight,
        handleChangeReplyMessageHeight,
      }}
    >
      {children}
    </Context.Provider>
  );
};
